import {
  deleteCard,
  setDefaultCard,
} from "../../../../Redux/Profile/ProfileActions";
import ConfirmationModal from "../../../Common/ConfirmationModal/ConfirmationModal";
import { AppDispatch, RootState } from "../../../../Redux/store";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import Mastercard from "../../../../Assets/Mastercard.png";
import AddCardModal from "../AddCardModal/AddCardModal";
import { useDispatch, useSelector } from "react-redux";
import styles from "./PaymentMethods.module.scss";
import { HiDotsVertical } from "react-icons/hi";
import Visa from "../../../../Assets/Visa.png";
import React, { useState } from "react";

function PaymentMethods() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteCardId, setDeleteCardId] = useState<number>(-1);
  const { profileData, deleteCardLoading } = useSelector(
    (state: RootState) => state.profile,
  );
  const dispatch = useDispatch<AppDispatch>();

  const cardTypeRenderer = (type: string) => {
    const cardType = type?.toUpperCase();
    switch (cardType) {
      case "VISA":
        return (
          <div className={styles.paymentMethodIcon}>
            <img className={styles.image} src={Visa} alt="VISA" />
          </div>
        );

      case "MASTERCARD":
        return (
          <div className={styles.paymentMethodIcon}>
            <img className={styles.image} src={Mastercard} alt="MASTERCARD" />
          </div>
        );
      default:
        return <></>;
    }
  };

  const setDefaultHandler = (cardId: number) => {
    dispatch(setDefaultCard({ memberCCInfoId: cardId }));
  };

  const deleteCardHandler = (cardId: number) => {
    setIsDeleteModalOpen(true);
    setDeleteCardId(cardId);
  };

  const deleteCardConfirmationHandler = () => {
    const successHandler = () => {
      setIsDeleteModalOpen(false);
      setDeleteCardId(-1);
    };
    dispatch(
      deleteCard({
        id: deleteCardId.toString(),
        successHandler,
      }),
    );
  };

  return (
    <React.Fragment>
      <AddCardModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        onConfirm={deleteCardConfirmationHandler}
        heading="Delete Card"
        text="Are you sure you want to delete this card?"
        loading={deleteCardLoading}
      />
      <div className={styles.mainContainer}>
        {profileData?.memberCCInfo?.map((item: any, i: number) => (
          <div key={i} className={styles.paymentMethodsList}>
            <div className={styles.paymentMethod}>
              {cardTypeRenderer(item?.cardtype)}
              <div className={styles.paymentMethodDetails}>
                <p className={styles.paymentMethodNumber}>
                  XXX - {item?.cardNumber}
                </p>
              </div>
            </div>
            <div className={styles.paymentMethodRight}>
              {item?.isDefault && (
                <div className={styles.defaultPaymentMethod}>
                  <p className={styles.label}>DEFAULT</p>
                </div>
              )}

              <div className={styles.iconContainer}>
                <Menu
                  menuButton={
                    <MenuButton>
                      <HiDotsVertical className={styles.icon} size={20} />
                    </MenuButton>
                  }
                  transition
                >
                  {!item?.isDefault && (
                    <MenuItem onClick={() => setDefaultHandler(item?.id)}>
                      Set as default
                    </MenuItem>
                  )}
                  <MenuItem onClick={() => deleteCardHandler(item?.id)}>
                    Delete
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </div>
        ))}

        <div className={styles.buttonContainer}>
          <button
            className={styles.button}
            onClick={() => setIsModalOpen(true)}
          >
            Add New Card
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PaymentMethods;
